import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import './message.scss';
import { resetHandbookError } from '../../../redux/actions/handbookAction';

const Message = ({ type, text }) => {
  const dispatch = useDispatch()
  let fullText = null;
  if (typeof text === 'object') {
    fullText = `${text.message}. Договор №${text.dealId}`;
  }

  useEffect(() => {
    dispatch(resetHandbookError())
  }, [])

  return (
    <div className="message-container">
      <div className={'message ' + type}>
        {/* Available classes: info, success, error, warning */}
        <p>{fullText || text}</p>
      </div>
    </div>
  );
};

export default Message;
